module.exports = __webpack_public_path__ + "img/9.00e05345.png";